<div class="container">
    <div *ngIf="brand" fxLayout="row wrap" fxLayoutAlign="center center">
        <div
            fxFlex="100"
            fxFlex.gt-md="25"
            fxFlex.md="25"
            fxFlex.sm="50"
            fxLayoutAlign="center center"
            style="cursor: pointer"
            *ngFor="let brandImage of brand.images; index as i"
        >
            <div class="card-image" (click)="redirectBrand(brand, brandImage)">
                <img  loading="lazy"  [src]="brandImage.image"    alt="{{ brand.name }}-{{ i }}" />
            </div>
        </div>
    </div>
</div>
